exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".locked{pointer-events:none}*{text-rendering:auto;-webkit-font-smoothing:antialiased;font-family:Source Sans Pro,HelveticaNeue-Light,Helvetica Neue Light,Helvetica Neue,Helvetica,Arial,Lucida Grande,sans-serif;-webkit-margin-before:0;-webkit-margin-after:0;-webkit-margin-start:0;-webkit-margin-end:0;-webkit-padding-start:0}ul{-webkit-padding-start:20px}body{padding:0;margin:0}b{font-weight:600}h1,h2{font-weight:400}h1{padding:20px 0;color:#ef3d23}.page{max-width:1140px;margin-left:auto;margin-right:auto;padding:0 40px;overflow-x:hidden;text-align:center}.page.wide{max-width:100%;padding:0}.page.wide .content,.page main{width:100%;float:left}.content{padding-top:20px;padding-bottom:40px}a{text-decoration:none;color:inherit}::placeholder{opacity:.7}:-ms-input-placeholder,::-ms-input-placeholder{opacity:.7}@media (max-width:520px){.page{padding:0 20px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5a205d2e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 19
// module chunks = 24